// ─── Blog Post Registry ────────────────────────────────────────────────────────
// To add a new post:
// 1. Create src/posts/your-slug.js  (copy the format from any existing post)
// 2. Import it below
// 3. Add an entry to the POSTS array — newest first
// That's it — it will appear on /blog and be reachable at /blog/your-slug
// ──────────────────────────────────────────────────────────────────────────────

import eightyTwentyRule from "./80-20-rule-tipped-employees";
import tipCreditByState from "./tip-credit-by-state-2026";

export const POSTS = [
  eightyTwentyRule,
  tipCreditByState,
];

export function getPost(slug) {
  return POSTS.find((p) => p.slug === slug) || null;
}
